module.exports = __webpack_public_path__ + "images/feature/20160901_02-b34663037f6979712d41fa280a35054b.png";